// Copilot: Footer component with legal page navigation links
// Provides links to terms, privacy, cookies, accessibility pages and contact info

import React from 'react';

interface FooterProps {
  onNavigate: (page: string) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer className="bg-slate-700 text-white py-8 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Legal Section */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Legal</h3>
            <div className="space-y-3">
              <button
                onClick={() => onNavigate('terms')}
                className="block text-gray-300 hover:text-white transition-colors duration-200 text-left"
              >
                Terms of Service
              </button>
              <button
                onClick={() => onNavigate('privacy')}
                className="block text-gray-300 hover:text-white transition-colors duration-200 text-left"
              >
                Privacy Policy
              </button>
              <button
                onClick={() => onNavigate('cookies')}
                className="block text-gray-300 hover:text-white transition-colors duration-200 text-left"
              >
                Cookie Policy
              </button>
              <button
                onClick={() => onNavigate('accessibility')}
                className="block text-gray-300 hover:text-white transition-colors duration-200 text-left"
              >
                Accessibility
              </button>
            </div>
          </div>
          
          {/* Contact Section */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contact</h3>
            <div className="space-y-2">
              <a 
                href="mailto:hello@itsmyapp.co.uk" 
                className="text-blue-400 hover:text-blue-300 transition-colors duration-200 block"
              >
                hello@itsmyapp.co.uk
              </a>
            </div>
          </div>
        </div>
        
        {/* Bottom branding section */}
        <div className="border-t border-slate-600 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-2 mb-4 md:mb-0">
            <img 
              src="/its_my_merge.png" 
              alt="Its My Keybox" 
              className="h-6 w-auto"
            />
            <span className="text-gray-300 text-sm">
              Powered by Its My Merge developed by itsmyapp.co.uk Copyright 2025
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;